import {pluralize} from "@pg-mono/string-utils";

const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

export const formatMetaRooms = (minRooms: number, maxRooms: number): string => {
    if (minRooms === maxRooms) {
        return `${minRooms} ${roomsPluralize(minRooms)}`;
    }

    return `${minRooms}-${maxRooms} ${roomsPluralize(maxRooms)}`;
};
